import React from 'react';

// Two-pane shell for scan-driven work: a fixed-width rail beside a main pane,
// under a thin context bar.
//
// Below the tablet breakpoint the rail cannot be persistent — the scan workflow
// is one-handed on a tablet and a 340px rail leaves too little room for the
// checklist — so `stacked` collapses to a single column and the parent decides
// which pane to render. That keeps the pre-reskin alternating model intact on
// the devices that actually rely on it.
export default function WorkbenchLayout({ topbar, rail, children, stacked, railWidth = 340 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 }}>
      {topbar && (
        <div style={{
          flexShrink: 0, display: 'flex', alignItems: 'center', gap: 'var(--space-3)',
          flexWrap: 'wrap', minHeight: 48, padding: 'var(--space-2) 0',
          borderBottom: '1px solid var(--border-subtle)', marginBottom: 'var(--space-4)',
        }}>{topbar}</div>
      )}

      <div style={{
        flex: 1, minHeight: 0, display: 'flex', gap: 'var(--space-4)',
        flexDirection: stacked ? 'column' : 'row',
      }}>
        {rail && (
          <div style={{
            flexShrink: 0, minHeight: 0,
            width: stacked ? '100%' : railWidth,
            maxHeight: stacked ? 260 : 'none',
            display: 'flex', flexDirection: 'column',
          }}>{rail}</div>
        )}
        <div style={{ flex: 1, minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
